import { EntityBase } from 'projects/sepidz-web-framework/src/lib/models/entity-base.model';
import { PrintTemplate } from './print-template.model';

export class PrintPolicy extends EntityBase {
  public Title: string;
  public PrintTimeId?: number;
  public PrintTimeTitle: string;
  public PrintTimeCode?: number;
  public PrintTemplateId: number;
  public PrintTemplateName: string;
  public Printers: PrintPolicyPrinter[];
  public Items: PrintPolicyItem[];
  public Categories: PrintPolicyItemCategory[];
  public IgnoredItems: PrintPolicyIgnoredItem[];
  public SaleMethodBranches: PrintPolicySaleMethodBranch[];
  public Salons: PrintPolicySalon[];
  public Dependents: PrintPolicyDependency[];
  public Description: string;
  public PrintTemplate  : PrintTemplate ;
  public HasLocalSetting:boolean;
  public IsOrderPrint:boolean;
  public IsReceiptPrint:boolean;
  public NonDefaultPrinting:boolean;
  public LocalServiceIp : string;
  public ComputerName: string;
  public InvalidChangeTemplate: boolean;
}

export class PrintPolicyPrinter extends EntityBase {
  public Name: string;
  public PrintPolicyId: number;
  public PrintPolicy : PrintPolicy;
}
export enum PrintTemplateType
{
    None = 1,
    Preparation = 2,
    Customer = 3,
}
export class PrintPolicyItem extends EntityBase {
  public ItemId: number;
  public PrintPolicyId: number;
}

export class PrintPolicyItemCategory extends EntityBase {
  public ItemCategoryId: number;
  public PrintPolicyId: number;
}

export class PrintPolicyIgnoredItem extends EntityBase {
  public ItemId: number;
  public PrintPolicyId: number;
}

export class PrintPolicySaleMethodBranch extends EntityBase {
  public SaleMethodBranchId: number;
  public PrintPolicyId: number;
}

export class PrintPolicySalon extends EntityBase {
  public SalonId: number;
  public PrintPolicyId: number;
}

export class PrintPolicyDependency extends EntityBase {
  public DependentPrintPolicyId: number;
  public PrintPolicyId: number;
  public PrincipalPrintPolicy : PrintPolicy;
  DependentPrintPolicy : any;
}

export enum PrintPolicyPrintTimeEnum {
  PreparationPrint = 1,
  CustomerPrint = 2
}
export class PrintTemplateModel extends EntityBase{
  public title: string;
}

export class PrintPolicyValidationInfo {
  /// <summary>
  /// کالا
  /// </summary>
  public ItemsIds: number[];

  /// <summary>
  /// گروه کال
  /// </summary>
  public CategoriIds: number[];

  /// <summary>
  /// سالن
  /// </summary>
  public SalonsIds: number[];

  /// <summary>
  /// نحوه فروش
  /// </summary>
  public SaleMethodIds: number[];

  /// <summary>
  /// نوع سیاست چاپ
  /// </summary>
  public PrintTimeId: number;
    /// <summary>
  /// کد نوع سیاست چاپ
  /// </summary>
  public PrintTimeCode: number;
  /// <summary>
  /// چاپگر محلی بلی/خیر
  /// </summary>
  public PrinterIsDefault?: boolean;
}
